mutation ResetPollCounts($pollId: ID!, $clearDedupe: Boolean) {
  poll: StreamToolsResetPollCounts(pollId: $pollId, clearDedupe: $clearDedupe) {
    pollId
    status
    startedAt
    stoppedAt
    graceEndsAt
    version
    totalVotes
    options {
      optionId
      voteCount
      voteCountByPlatform { twitch youtube }
    }
  }
}
